module.exports = __webpack_public_path__ + "img/upload1.cbef2bf5.png";